import React from 'react'
import { PraxisPlusBanner } from './PraxisPlusBanner'
import { BricoPlusBanner } from './BricoPlusBanner'
import { PRAXIS } from 'chemistry'

export const PromotionPlusBanner = props => {
  if (props.format === PRAXIS) return <PraxisPlusBanner {...props} />
  return <BricoPlusBanner {...props} />
}
